import axios from "axios";

const BASE_URL = process.env.VUE_APP_MIRAI_BASE_URL || "https://api-integration.clubdacotacao.com.br/v3/intelligence";

export function suggestionCodeKey(code) {
    const value = String(code == null ? "" : code).trim();
    return /^\d+$/.test(value) ? value.replace(/^0+(?=\d)/, "") : value;
}

export function buildSuggestionAlgoritmo(algorithm) {
    const { estoque, pendencia, cobertura, cobertura_dias, giro } = algorithm;
    const unidade = algorithm.unidade === "unidade_compra" ? "unidade_compra" : "unidade";
    const algoritmo = { estoque, pendencia, cobertura, giro, unidade };
    if (cobertura === "cobertura_fixa") {
        algoritmo.cobertura_dias = cobertura_dias;
    }
    return algoritmo;
}

export function suggestionQuantity(product, row, algoritmo) {
    if (Number(product.pro_generico) === 1) {
        return Number(row.suggestion_units) || 0;
    }
    if (algoritmo.unidade === "unidade_compra") {
        return Number(row.suggestion) || 0;
    }
    const partes = String(product.pro_embalagem || "").trim().split(" ");
    const fator = parseFloat(partes[1]) || 1;
    const caixas = (Number(row.suggestion_units) || 0) / fator;
    return algoritmo.cobertura === "cobertura_fixa" ? Math.ceil(caixas) : Math.round(caixas);
}

export default class MiraiService {
    constructor(cliId) {
        this.cliId = process.env.VUE_APP_MIRAI_CLI_ID || cliId;
    }

    stockCost(internalCodes) {
        return axios.get(`${BASE_URL}/products/${this.cliId}/stock-cost`, {
            params: { id_produto__in: internalCodes.join(",") },
            timeout: 120000,
        });
    }

    suggestion({ storeNumber, internalCodes, algoritmo }) {
        return axios.get(`${BASE_URL}/products/${this.cliId}/suggestion`, {
            params: {
                store_number: storeNumber,
                internal_codes: internalCodes.join(","),
                algoritmo: JSON.stringify(algoritmo),
            },
            timeout: 240000,
        });
    }
}
